// import local dependencies
import Router from './util/Router';
import blog from './routes/blog';

/** Populate Router instance with DOM routes */
const routes = new Router({
    // The blog/news page
    blog,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());
